jQuery(document).ready(function($) {
	var shrinkHeader = 50;
	var shrinkSubHeader = 212;

	$(window).scroll(function() {
		var scroll = getCurrentScroll();
		if ( scroll >= shrinkHeader ) {
			$('.navbar').addClass('fixed');
		}
		else {
			$('.navbar').removeClass('fixed');
		}
	});

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	$('.select-2').select2({
		dropdownAutoWidth : true
	});

	var $grid = $('.iso-items').isotope({ 
		itemSelector: '.iso-item', layoutMode: 'fitRows', transitionDuration: 0, getSortData: { 
			start: function (itemElem) { 
				var startDate = $( itemElem ).data('start');
				return parseFloat( startDate );
			}, price: function (itemElem) { 
				var price = $( itemElem ).data('price');
				return parseInt( price );
			} }, 
			sortBy: [ 'start' ] 
		});

	$('.iso-filters').on( 'click', 'a.iso-filter', function(e) {e.preventDefault();
		var item = $(this), links = $('.iso-filter'), category = item.data('filter');
		links.removeClass('iso-filter-selected');
		item.addClass('iso-filter-selected');
		$grid.isotope({filter: category });
	});
	var filters = {};
	$(document).on('change', '.iso-select-filter', function(e) {
		var filter = $(this).attr('name');
		filters[ filter ] = $(this).val();
		$grid.isotope({filter: function() {var found = false;
			for (var key in filters) {
				if (key == 'budget') {
					if ($(this).data('budget') <= filters[key]) {
						found = true;
					} else {
						return false;
					}
				} else {
					if (filters[key] == '*') {
						found = true;
					} else {
						var regex = new RegExp( filters[key], 'g' ), 
						str = $(this).data(key) ? $(this).data(key).toString() : '';
						if (str.match(regex)) {
							found = true;
						} else {
							return false;
						} 
					} 
				} 
			} 
			return found;
		} });
	});
	$(document).on('change', '.sortby', function() {var option = $(this).find(':selected'), sortBy = option.data('sort_by'), order = option.data('order') == 'asc' ? true : false;
		$grid.isotope({sortBy: sortBy, sortAscending: order });
	});
	$(document).on('change', '#cruise_type', function() {
		var c = $(this).val();
		if (c != '*') {
			var regex = new RegExp( c, 'g' );
			$('#cruise_line').find('option').each(function(item) {

				var str = $(this).data('categories');
				if (str) {
					if (str.match(regex)) {
						$(this).attr('disabled', false);
					} else {
						$(this).attr('disabled', true);
					}
				}
			});
		} else {
			$('#cruise_line').find('option').each(function(item) {
				$(this).attr('disabled', false);
			});
		}
	});
});